import React from 'react';
import { X, AlertTriangle, Check, X as XIcon } from 'lucide-react';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "确认删除", 
  message = "确定要删除吗？此操作不可撤销。",
  confirmText = "删除",
  cancelText = "取消",
  type = "danger" // danger, warning, info
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <AlertTriangle size={24} className="text-red-500" />;
      case 'warning':
        return <AlertTriangle size={24} className="text-yellow-500" />;
      case 'info':
        return <AlertTriangle size={24} className="text-blue-500" />;
      default:
        return <AlertTriangle size={24} className="text-red-500" />;
    }
  };

  const getButtonClass = () => {
    switch (type) {
      case 'danger':
        return 'btn btn-danger';
      case 'warning':
        return 'btn btn-warning';
      case 'info':
        return 'btn btn-primary';
      default:
        return 'btn btn-danger';
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-md relative" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100 z-10 flex items-center justify-center"
        >
          <X size={18} />
        </button>

        <div className="modal-header">
          <div className="flex items-center gap-3">
            {getIcon()}
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>
        </div>

        <div className="modal-body">
          <p className="text-gray-600">{message}</p>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onConfirm}>
            <Check size={16} className="mr-2" />
            {confirmText}
          </button>
          <button className="btn btn-danger" onClick={onClose}>
            <XIcon size={16} className="mr-2" />
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
